export const defaultColumns = [
  {label: 'Marca', value: 'brand'},
  {label: 'Categoria', value: 'category_display_name'},
  {label: 'Modelo', value: 'display_name'},
  {label: 'Ano', value: 'year'},
  {label: 'Produtos Aplicáveis', value: 'fuel'},
  {label: 'Ações', value: 'actions', className: 'w-10'},
]
